import React from 'react'

// Full-page "no access" landing for non-member acknowledgment recipients.
// Mounted by Packages::ModalsController via the modal.ny_1120b_acknowledgment hook.
// orgName is passed by the backend but intentionally not displayed (per Figma).
export default function AcknowledgmentNoAccess() {
  return (
    <div className="acknowledgment-no-access dome-d-flex dome-flex-column dome-gap24">
      <div className="dome-h2 dome-color-red-alert">application package access denied</div>
      <div className="dome-d-flex dome-flex-column dome-gap24 dome-color-dark-grey">
        <div className="dome-d-flex dome-flex-column dome-gap12">
          <div className="dome-p1">You do not have permission to view this application.</div>
          <div className="dome-p1">Contact property management or the application owner for more information.</div>
        </div>
        <div className="dome-d-flex dome-align-center dome-justify-start">
          <a href="/" className='dome-link dome-link-cancel dome-color-med-grey'> return to dashboard</a>
        </div>
      </div>
    </div>
  )
}
